import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

export const RULE_BY_UUID_RESOURCE = "rule" as const;
export const RULE_BY_UUID_API_PATH = `/v1/${RULE_BY_UUID_RESOURCE}/{uuid}` as const;

export type RuleByUuidParameters = paths[typeof RULE_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type RuleByUuidResponse =
  paths[typeof RULE_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useRuleByUuidQuery(uuid: string, options?: Options<RuleByUuidParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<RuleByUuidParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    enabled: !!uuid,
    queryKey: [RULE_BY_UUID_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<RuleByUuidResponse>(`/v1/${RULE_BY_UUID_RESOURCE}/${uuid}`, {
        params: requestParameters,
      });

      return response.data;
    },
  });
}
